import MENU_SPRITE_ICON from 'assets/svg/menu-sprite.svg';

export const navLinks = {
  home: {
    id: 'home',
    label: 'Home',
    labelMobile: 'Home',
    link: '/dashboard',
  },
  view_all_tickets: {
    id: 'view_all_tickets',
    label: 'View all tickets',
    labelMobile: 'View all ticket',
    link: '/admin/tickets',
  },
  open_a_ticket: {
    id: 'open_a_ticket',
    label: 'Open a ticket',
    labelMobile: 'Open a ticket',
    link: '/open_a_ticket',
  },
  detail_view_all_tickets: {
    id: 'detail_view_all_tickets',
    label: '',
    labelMobile: '',
    link: '/admin/tickets/:id',
  },
  logout: {
    id: 'logout',
    label: 'logout',
    labelMobile: 'logout',
    link: '/',
    icon: 'sign-out',
  },
  open_user_tiket: {
    id: 'open_user_tiket',
    label: 'Open user ticket',
    labelMobile: 'Open user ticket',
    link: '/admin/usertickets/create',
  },
  open_internal_tiket: {
    id: 'open_internal_tiket',
    label: 'Open internal ticket',
    labelMobile: 'Open internal ticket',
    link: '/admin/internaltickets/create',
  },
  view_user_tikets: {
    id: 'view_user_tikets',
    label: 'View user tickets',
    labelMobile: 'View user tickets',
    link: '/admin/tickets',
  },
  view_internal_tikets: {
    id: 'view_internal_tikets',
    label: 'View internal tickets',
    labelMobile: 'View internal tickets',
    link: '/admin/internaltickets',
  },
  changelog: {
    id: 'changelog',
    label: 'Changelog',
    labelMobile: 'Changelog',
    link: '/admin/changelog',
  },
  admin_kb_macros_create: {
    id: 'new_macro',
    label: 'New macro',
    labelMobile: 'New macro',
    link: '/admin/kb/macros/create',
  },
  admin_kb_macros: {
    id: 'macro',
    label: 'Macro',
    labelMobile: 'macro',
    link: '/admin/kb/macros',
  },
  admin_kb_macros_id: {
    id: 'admin_kb_macros_id',
    label: '',
    labelMobile: '',
    link: '/admin/kb/macros/:id',
  },
  admin_tickets_create: {
    id: 'admin_tickets_create',
    label: 'Create a ticket',
    labelMobile: 'Create a ticket',
    link: '/admin/tickets/create',
  },
};

export const sideNavLinks = () => {
  return [
    {
      indexNumber: 0,
      id: 'support',
      label: 'Support',
      labelMobile: 'Support',
      icon: MENU_SPRITE_ICON,
      classes: 'iserver',
      links: [
        navLinks.home,
        navLinks.open_user_tiket,
        navLinks.open_internal_tiket,
        navLinks.view_user_tikets,
        navLinks.view_internal_tikets,
      ],
      mobileLinks: [
        navLinks.home,
        navLinks.open_user_tiket,
        navLinks.open_internal_tiket,
        navLinks.view_user_tikets,
        navLinks.view_internal_tikets,
      ],
    },
    {
      indexNumber: 1,
      id: 'changelog',
      label: 'changelog',
      labelMobile: 'changelog',
      icon: MENU_SPRITE_ICON,
      classes: 'ilog',
      links: [navLinks.changelog],
      mobileLinks: [navLinks.changelog],
    },
  ];
};
